import { createAction, props } from '@ngrx/store';
import { DataSource } from '@sharedModule/models/data-source.model';
import { SenderListInterface } from '../types/sender-list';
import { SenderListFilter } from '../types/sender-list-filter';

export const fetchSenderList = createAction(
  '[Sender List] Sender List Fetch',
  props<{ filter?: SenderListFilter }>()
);

export const updateSenderListFilter = createAction(
  '[Sender Filter] Sender List update filter',
  props<{ filter?: SenderListFilter }>()
);

export const loadedSenderList = createAction(
  '[Sender List] Sender List Loaded',
  props<{ dataSource: DataSource<SenderListInterface[]> }>()
);

export const failedSenderList = createAction(
  '[Sender List] Sender List Failed'
);

export const resetSenderList = createAction('[Sender List] Reset Sender List');
